import { AdSystemStateT, AdSystemT, useOrganizationMonthlyBudgetQuery } from "../graphql/generated/graphql";
import { useWizardState } from "./useWizardState";

type BudgetCreditCheckT = {
  insufficientCredit: boolean;
  missingCredit: number;
};

const daysInCurrentMonth = () => {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
};

export const useBudgetCreditCheck = (
  adSystem: AdSystemT,
  newMonthlyBudget: number,
  currentMonthlyBudget: number
): BudgetCreditCheckT => {
  const { data } = useOrganizationMonthlyBudgetQuery();
  const { googleWizardFinished, metaWizardFinished } = useWizardState();

  const wizardFinished = adSystem === AdSystemT.GoogleAdsT ? googleWizardFinished : metaWizardFinished;
  const otherSetting =
    adSystem === AdSystemT.GoogleAdsT ? data?.organization?.metaAdsSetting : data?.organization?.googleAdsSetting;

  const daysInMonth = daysInCurrentMonth();
  const creditBalance = data?.organization?.creditBalance?.amount || 0;
  const newDailyBudget = newMonthlyBudget / daysInMonth;
  const otherDailyBudget =
    otherSetting?.state === AdSystemStateT.ActiveT ? (otherSetting.monthlyBudget?.amount || 0) / daysInMonth : 0;
  const missingCredit = newDailyBudget + otherDailyBudget - creditBalance;
  const isIncrease = newMonthlyBudget > currentMonthlyBudget;

  return {
    insufficientCredit: wizardFinished && isIncrease && missingCredit > 0,
    missingCredit,
  };
};
